import { computed, unref } from 'vue'

/**
 * 根据 FAQ 列表生成 FAQPage JSON-LD。
 * @param {import('vue').MaybeRefOrGetter<Array<{ question: string, answer: string }>>} faqItems
 */
export function useMarketingLandingFaqSchema(faqItems) {
  const faqSchema = computed(() => {
    const items = unref(faqItems)
    if (!Array.isArray(items) || items.length === 0) return null

    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: items.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    }
  })

  useHead(() => {
    if (!faqSchema.value) return {}
    return {
      script: [
        {
          type: 'application/ld+json',
          key: 'marketing-landing-faq',
          tagPosition: 'bodyClose',
          children: JSON.stringify(faqSchema.value),
        },
      ],
    }
  })

  return { faqSchema }
}
